import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

import { useRoute } from 'vue-router'
import { computed } from 'vue'
import PublicLayout from '@/layouts/PublicLayout.vue'
import { useAuthStore } from '@/store/auth'
import { storeToRefs } from 'pinia'
import i18n from './i18n'
import { watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const authStore = useAuthStore()
const { selectedCompanyId } = storeToRefs(authStore)
const key = computed(() => {
  return `${route.fullPath} ${selectedCompanyId.value}`
})

watch(
  () => i18n.global.locale.value,
  () => {
    document.documentElement.lang = i18n.global.locale.value as string
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layout || PublicLayout), null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_component_router_view, { key: _unref(key) }))
    ]),
    _: 1
  }))
}
}

})